// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.trustmanagement

import org.multipaz.cbor.DataItem
import org.multipaz.trustmanagement.TrustEntryRical
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.trustmanagement.TrustMetadata
import org.multipaz.cbor.Bstr
import org.multipaz.trustmanagement.toDataItem
import org.multipaz.trustmanagement.fromDataItem

fun TrustEntryRical.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "wMpap1g4kXkCQV7_bj_XX_ExI3qGOHb6K64nWPcTVmg")
val TrustEntryRical_cborSchemaId = ByteString(-64, -54, 90, -89, 88, 56, -111, 121, 2, 65, 94, -1, 110, 63, -41, 95, -15, 49, 35, 122, -122, 56, 118, -6, 43, -82, 39, 88, -9, 19, 86, 104)

fun TrustEntryRical.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Rical")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("metadata", this.metadata.toDataItem())
    builder.put("encodedSignedRical", Bstr(this.encodedSignedRical.toByteArray()))
    return builder.end().build()
}

fun TrustEntryRical_fromDataItem(dataItem: DataItem): TrustEntryRical {
    val identifier = dataItem["identifier"].asTstr
    val metadata = TrustMetadata.fromDataItem(dataItem["metadata"])
    val encodedSignedRical = ByteString(dataItem["encodedSignedRical"].asBstr)
    return TrustEntryRical(
        identifier = identifier,
        metadata = metadata,
        encodedSignedRical = encodedSignedRical,
    )
}
